const employment = {
  employmentPhrase1:
    "アートデモクラタイゼーションや、文化促進にご興味がお有りですか？",
  employmentPhrase2: "お問合せフォームより、メッセージをお送り下さい！",
};

module.exports = employment;
